export const checkIsDefaultDomain = (currentHostname: string, defaultDomain: string): boolean => {
  if (currentHostname.includes("localhost")) {
    const params = new URLSearchParams(window.location.search);
    if (params.get("platform") === "airline") {
      return false;
    }
    let hostNameToCheck = currentHostname.replace("localhost", defaultDomain);
    return hostNameToCheck === defaultDomain;
  } else {
    return currentHostname === defaultDomain;
  }
};
